import { formatEventTypeLockAttributes } from '../../utils'

export const getInitialValues = ({ event_type_lock: eventTypeLock }) => ({
  lockingRules: eventTypeLock ? eventTypeLock.locking_rules : []
})


export const getFormatValuesToServerData = (eventType) => (values) => {
  if (!eventType.isMETParent) { return {} }

  return {
    event_type_lock_attributes: formatEventTypeLockAttributes(values)
  }
}
